import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { Message, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import Table from '../../components/Table';
import Modal from './Modal';
import AddButton from '../../components/Button/AddButton';
import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import { Container, Header, Title } from './styles';

import { GET_MALL_ACCESS } from '../../services/graphql/queries';

const columns = [
  { id: 'name', label: 'Nombre', minWidth: 100 },
  { id: 'code', label: 'Codigo', minWidth: 20 },
  { id: 'mall_name', label: 'Centro Comercial', minWidth: 100 },
  { id: 'lat', label: 'Latitude', minWidth: 100 },
  { id: 'lon', label: 'Longitud', minWidth: 100 },
  { id: 'address', label: 'Dirección', minWidth: 50 },
  { id: 'active', label: 'Activo', minWidth: 100 },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

export default function CamerasConfiguration() {
  const [open, setOpen] = useState(false);
  const [mallsOptions, setMallsOptions] = useState([]);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});

  const configNotification = useSelector(
    state => state.notification.configCount
  );

  const { loading, error, data, refetch } = useQuery(GET_MALL_ACCESS);

  useEffect(() => {
    if (data) {
      if (data.getMalls) {
        setMallsOptions(
          data.getMalls.filter((data, index) => index !== 0).map(mall => ({
            key: mall.id,
            text: `${mall.name} - ${mall.code}`,
            value: mall.id,
            country_id: mall.country_id
          }))
        );
      }
    }
  }, [data]);

  useEffect(() => {
    if (configNotification > 0 && configNotification < 2) {
      toast.warn(
        'Tienes una configuración de acceso pendiente (centro comercial sin asignar).',
        {
          autoClose: 7000
        }
      );
    } else if (configNotification > 1) {
      toast.warn(
        `Tienes ${configNotification} configuraciones de accesos pendientes (centro comercial sin asignar).`,
        {
          autoClose: 7000
        }
      );
    }
  }, [configNotification]);

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="cameras-configuration-component">
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Accesos</Title>
            <AddButton add onClick={handleAdd} />
          </Header>
          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={data ? data.getMallAccess.filter((data, index) => index !== 0) : null}
              columns={columns}
              handleEdit={handleEdit}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            malls={mallsOptions}
            edit={edit}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
